import React, { useMemo } from 'react';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import { columnDefs } from './definitions-config';
import { Icon } from 'semantic-ui-react';
import './index.css';

function JobGroupsTable({ rowData, setSortType, setSortColumn }) {
  const ButtonRenderer = (params) => {
    return (
      <div className='relative flex items-center '>
        <Icon name='ellipsis horizontal' />
      </div>
    );
  };

  const frameworkComponents = {
    btnCellRenderer: ButtonRenderer,
  };
  const rowStyle = { background: 'white' };

  const getRowStyle = (params) => {
    return {
      background: 'white',
      borderBottom: '1px solid #e6e6e6',
      fontSize: '16px',
      color: '#5E6E88',
    };
  };

  const CustomLoadingOverlay = (props) => {
    return (
      <div className='ag-overlay-loading-center'>
        <i className='fas fa-hourglass-half'> {props.loadingMessage} </i>
      </div>
    );
  };

  const loadingOverlayComponentParams = useMemo(() => {
    return {
      loadingMessage: 'One moment please...',
    };
  }, []);

  return (
    <div className='ag-theme-balham' style={{ height: '75vh', width: '100%' }}>
      <AgGridReact
        columnDefs={columnDefs}
        // defaultColDef={defaultColDef}
        rowStyle={rowStyle}
        getRowStyle={getRowStyle}
        rowHeight={50}
        rowData={rowData || []}
        tooltipShowDelay={0}
        tooltipHideDelay={2000}
        suppressPaginationPanel
        loadingOverlayComponent={CustomLoadingOverlay}
        loadingOverlayComponentParams={loadingOverlayComponentParams}
        onGridReady={(params) => {
          params.api.sizeColumnsToFit();
          // params.api.showLoadingOverlay();
        }}
        onGridSizeChanged={(params) => {
          params.api.sizeColumnsToFit();
        }}
        frameworkComponents={frameworkComponents}
        onSortChanged={(params) => {
          const column = params?.columnApi
            ?.getColumnState()
            ?.filter((item) => item.sort)?.[0];
          if (!column) return;
          if (column.colId) {
            if (column.colId === 'createdAt') {
              setSortType(column.sort.toUpperCase());
              setSortColumn(column.colId);
            }
            if (column.colId === 'lastGroupActivity') {
              setSortType(column.sort.toUpperCase());
              setSortColumn(column.colId);
            }
            if (column.colId === 'company') {
              setSortType(column.sort.toUpperCase());
              setSortColumn(column.colId);
            }
            if (column.colId === 'studentsCount') {
              setSortType(column.sort.toUpperCase());
              setSortColumn(column.colId);
            }
            if (column.colId === 'highestProgressLevel') {
              setSortType(column.sort.toUpperCase());
              setSortColumn(column.colId);
            }
          }
        }}
      />
    </div>
  );
}

export default JobGroupsTable;
